const CURRENCY = 'CURRENCY'
const TICKET = 'TICKET'
const INSURANCE = 'INSURANCE'
const OTHER = 'OTHER'

export default {
    CURRENCY: CURRENCY,
    TICKET: TICKET,
    INSURANCE: INSURANCE,
    OTHER: OTHER,
    list: [
        {
            name: 'Moeda',
            value: CURRENCY
        },
        {
            name: 'Passagem',
            value: TICKET
        },
        {
            name: 'Seguros',
            value: INSURANCE
        },
        {
            name: 'Outros',
            value: OTHER
        }
    ]
}
